import LightOnIcon from './component'

export default LightOnIcon
